import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StrategyFlowAction } from './strategy-selection-drawer/strategy-selection-drawer.component';

@Injectable({
  providedIn: 'root',
})
export class StrategySelectionService {
  private readonly flowActionSubject = new Subject<StrategyFlowAction>();

  readonly flowAction$ = this.flowActionSubject.asObservable();

  emitFlowAction(action: StrategyFlowAction): void {
    this.flowActionSubject.next(action);
  }
}
